export default __webpack_public_path__ + "static/media/blockchain-image-4steg.14b2f277.jpg";